import { useEffect, useState, useRef, useCallback } from "react";
import { useLocation, useParams } from "react-router-dom";
import { useLang } from "../../context/langProvider";
import "./styles.css";
import JobModalForm from "../../components/JobModalForm";
import FormModalProjetClient from "../../components/FormModalProjetClient";
import SectionListePrestataire from "../../components/SectionListePrestataires";

export default function ServiceCategory() {
    const { categorySlug } = useParams();
    const [secteur, setSecteur] = useState(null);
    const [metierSelected, setMetierSelected] = useState(null);
    const apiUrl = process.env.REACT_APP_API_URL;
    const [loading, setLoading] = useState(false);
    const [showFormProjet, setShowFormProjet] = useState(false);
    const location = useLocation();
    const isEspacePrestataire = location.pathname.startsWith("/espace-prestataire");
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
    const [prestataires, setPrestataires] = useState([]);
    const [totalPrestataires, setTotalPrestataires] = useState(0);
    const scrollRef = useRef(null);
    const [metierFilter, setMetierFilter] = useState("");
    const [villeFilter, setVilleFilter] = useState("");
    const [rayonFilter, setRayonFilter] = useState(0); // km par défaut
    const [dispoFilter, setDispoFilter] = useState("any");
    const [experienceFilter, setExperienceFilter] = useState("any");
    const [noteFilter, setNoteFilter] = useState("any");
    const [page, setPage] = useState(1);
    const limit = 8; // nb prestataires par page
    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth <= 768);
        };

        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    // ⚡ ajuste automatiquement la durée d’animation
    useEffect(() => {
        const scrollContent = scrollRef.current;
        if (!scrollContent) return;

        const parent = scrollContent.parentElement;

        if (isMobile) {
            // Scroll horizontal
            const contentWidth = scrollContent.scrollWidth;
            const distance = contentWidth / 2; // car concat(metiers)
            const speed = 50; // px/seconde
            const duration = distance / speed;

            scrollContent.style.animationDuration = `${duration}s`;
        } else {
            // Scroll vertical
            const contentHeight = scrollContent.scrollHeight;
            const distance = contentHeight / 2;
            const speed = 50; // px/seconde
            const duration = distance / speed;

            scrollContent.style.animationDuration = `${duration}s`;
        }
    }, [secteur, isMobile]);


    const autoScrollMetiers = () => {
        return (
            secteur && secteur.metiers && (
                <div className="listServicesAutoScroll">
                    <div className="scroll-content" ref={scrollRef}>
                        {secteur.metiers.concat(secteur.metiers).map((srv, index) => (
                            <div
                                key={index}
                                className="service-item"
                                onClick={() => {
                                    setMetierSelected(srv);
                                    setShowFormProjet(true);
                                }}
                            >
                                <div className="img-service-item">
                                    <img
                                        src={`${apiUrl}/api/files/?categorie=metiers&file=${srv.iconMetier}`}
                                        alt={srv.labelMetier}
                                    />
                                </div>
                                <div className="name-service-item">{srv.labelMetier}</div>
                            </div>
                        ))}
                    </div>
                </div>
            )
        )
    }
    const totalPages = Math.ceil(totalPrestataires / limit);

    useEffect(() => {
        const url = `${apiUrl}/api/secteurs/${categorySlug}`;
        setLoading(true);
        fetch(url)
            .then((res) => res.json())
            .then((data) => setSecteur(data))
            .catch((err) => console.error("Erreur chargement services :", err))
            .finally(() => setLoading(false));
    }, [apiUrl, categorySlug]);
    const refreshPrestataires = useCallback(() => {
        const offset = (page - 1) * limit;
        setLoading(true);
        const params = new URLSearchParams({
            idSecteur: secteur.idSecteur,
            metier: metierFilter,
            ville: villeFilter,
            rayonKm: rayonFilter,
            offset: offset,
            limit: limit,

        });
        const url = `${apiUrl}/api/search/prestataires?${params.toString()}`;
        fetch(url)
            .then((res) => res.json())
            .then((data) => { setPrestataires(data.results); setTotalPrestataires(data.total) })
            .catch((err) => console.error(err))
            .finally(() => setLoading(false));
    }, [apiUrl, secteur, metierFilter, rayonFilter, villeFilter, page]);

    useEffect(() => {
        if (secteur)
            refreshPrestataires();
    }, [refreshPrestataires, secteur]);
    return (
        <main>
            {isMobile && autoScrollMetiers()}

            <section className="sectionServicePrincipal">
                {secteur && (
                    <div className="headerSectionServicePrincipal">
                        <p>{secteur.labelSecteur}</p>
                        <h1>
                            {!isEspacePrestataire
                                ? "Déposez un appel d'offre dans le secteur "
                                : "Consulter les appels d'offres du secteur d'activité "}
                            {secteur.labelSecteur}
                        </h1>
                        <p>
                            {!isEspacePrestataire ? (
                                <>
                                    Besoin d'un prestataire dans ce secteur ?{" "}
                                    <span>Vous êtes au bon endroit !</span>
                                    <br />
                                    👉 Déposez votre demande en un clic et recevez rapidement des devis
                                    de nos prestataires partenaires.
                                    <br />
                                    👉 Ou utilisez nos filtres intelligents pour trouver directement le
                                    professionnel idéal et lui demander un devis personnalisé.
                                </>
                            ) : (
                                <>
                                    Boostez votre activité avec les appels d'offres de{" "}
                                    <strong>{secteur.labelSecteur}</strong>. Choisissez votre métier
                                    pour cibler les projets qui vous intéressent, ou parcourez
                                    l'ensemble de la catégorie avec nos filtres intelligents ci-dessous.
                                    Gagnez du temps, trouvez les bons clients et développez votre
                                    chiffre d'affaires.
                                </>
                            )}
                        </p>
                        {!isEspacePrestataire && (
                            <button
                                className="btn-service"
                                onClick={() => {
                                    setShowFormProjet(true);
                                    setMetierSelected(null);
                                }}
                            >
                                Demander un service
                            </button>
                        )}
                    </div>
                )}

                {/* Liste scroll auto */}
                {!isMobile && autoScrollMetiers()}
            </section>

            {/* Filtres côté client */}
            {!isEspacePrestataire && secteur && (
                <section className="searchPrestataires">
                    <div>
                        <h2>
                            Rechercher des prestataires spécialisés dans le secteur{" "}
                            {secteur.labelSecteur}
                        </h2>
                        <div className="filters">
                            <div className="filter-item">
                                <label htmlFor="subCategory">Métiers</label>
                                <select
                                    name="subCategory"
                                    id="subCategory"
                                    value={metierFilter}
                                    onChange={(e) => setMetierFilter(e.target.value)}
                                >
                                    <option value="">Tous</option>
                                    {secteur.metiers.map((srv) => (
                                        <option value={srv.labelMetier} key={srv.idMetier}>
                                            {srv.labelMetier}
                                        </option>
                                    ))}
                                </select>
                            </div>
                            <div className="filter-item">
                                <label>Ville / Code postal</label>
                                <input
                                    type="text"
                                    placeholder="Ex: Paris, 75001"
                                    value={villeFilter}
                                    onChange={(e) => setVilleFilter(e.target.value)}
                                />
                            </div>
                            <div className="filter-item">
                                <label>Rayon</label>
                                <select
                                    value={rayonFilter}
                                    onChange={(e) => setRayonFilter(e.target.value)}
                                >
                                    <option value="0">Cette ville</option>
                                    <option value="10">10 km</option>
                                    <option value="25">25 km</option>
                                    <option value="50">50 km</option>
                                    <option value="100">100 km</option>
                                </select>
                            </div>
                            {/* <div className="filter-item">
                                <label>Disponibilité</label>
                                <select>
                                    <option value="any">Peu importe</option>
                                    <option value="now">Immédiate</option>
                                    <option value="7days">Sous 7 jours</option>
                                    <option value="later">Plus tard</option>
                                </select>
                            </div> */}
                            <div className="filter-item">
                                <label>Expérience</label>
                                <select>
                                    <option value="any">Peu importe</option>
                                    <option value="1">1+ an</option>
                                    <option value="3">3+ ans</option>
                                    <option value="5">5+ ans</option>
                                </select>
                            </div>
                            <div className="filter-item">
                                <label>Note minimale</label>
                                <select>
                                    <option value="any">Toutes</option>
                                    <option value="3">⭐ 3+</option>
                                    <option value="4">⭐ 4+</option>
                                    <option value="5">⭐ 5 uniquement</option>
                                </select>
                            </div>

                        </div>
                    </div>

                </section>
            )}
            <SectionListePrestataire total={totalPrestataires} listPrestataires={prestataires} />
            {/* Pagination */}
            {totalPages > 1 && (
                <div className="pagination">
                    <button
                        disabled={page === 1}
                        onClick={() => setPage((p) => p - 1)}
                    >
                        ⬅ Précédent
                    </button>
                    <span>
                        Page {page} / {totalPages}
                    </span>
                    <button
                        disabled={page === totalPages}
                        onClick={() => setPage((p) => p + 1)}
                    >
                        Suivant ➡
                    </button>
                </div>
            )}
            {/* Filtres côté prestataire */}
            {isEspacePrestataire && (
                <section className="searchOffersClients">
                    <div>
                        <h2>Rechercher des appels d'offres</h2>
                    </div>
                </section>
            )}

            {/* Modal */}
            {showFormProjet && (
                <FormModalProjetClient
                    onClose={() => setShowFormProjet(false)}
                    secteur={secteur}
                    metier={metierSelected}
                />
            )}
        </main>
    );
}
